<div class="ProductImage">
  @if ((product.url).indexOf('http')>-1) {
    <a [href]="productUrl$ | async" class="cx-product-image-container" tabindex="-1" target="_blank">
      <cx-media class="cx-product-image clp-image" [container]="product.image" format="300Wx300H" [alt]="product.name">
      </cx-media>
    </a>
    <div class="ProductName">
      <a [href]="productUrl$ | async" class="cx-product-name" [innerHTML]="product.name" target="_blank">
      </a>
    </div>
  }

  @if ((product.url).indexOf('http')<=-1) {
    <a [href]="productUrl$ | async" class="cx-product-image-container" tabindex="-1">
      <cx-media class="cx-product-image clp-image" [container]="product.image" format="300Wx300H" [alt]="product.name">
      </cx-media>
    </a>
    <div class="ProductName">
      <a [href]="productUrl$ | async" class="cx-product-name" [innerHTML]="product.name">
      </a>
    </div>
  }
</div>